import { ITranslationParameterMapping } from '../stores/TranslateStore';

export function parseParams(textValue: string, paramObject: ITranslationParameterMapping): string {
  return Object.keys(paramObject).reduce((text, key) => text.replace(`\${${key}}`, paramObject[key]), textValue);
}
